/**
 * Synapsy Widget - Launcher (Botão Flutuante)
 * Cria o botão persistente que abre o chat
 */

import { getLauncherStyles } from "./styles.js";

const ANA_AVATAR_URL = "https://ssa-assets.strelo.app/prod/site/shared/imgs/ana-avatar.png";

/**
 * Foto da Ana com o visual do AFROPUNK Brasil 2026, de 29/10 a 09/11 (horário de Salvador).
 * Mesma janela do ribbon e da foto do cabeçalho do chat (`ribbonAfropunkAtivo` em
 * `src/lib/config.ts`) — este bundle não importa de lá, então as datas se repetem aqui.
 *
 * A imagem mora no app do iframe (`public/afropunk/`), então a URL sai da origem dele: o
 * widget roda na página do aeroporto, onde um caminho relativo apontaria para o site deles.
 */
const AFROPUNK_INICIO = new Date("2026-10-29T00:00:00-03:00");
const AFROPUNK_FIM = new Date("2026-11-10T00:00:00-03:00");

export function avatarDoLauncher(iframeUrl, agora = new Date()) {
  if (agora < AFROPUNK_INICIO || agora >= AFROPUNK_FIM) return ANA_AVATAR_URL;
  try {
    return new URL("/afropunk/ana-avatar-afropunk.png", iframeUrl).href;
  } catch {
    return ANA_AVATAR_URL;
  }
}

/**
 * Cria o launcher (botão flutuante)
 * @param {Object} config - Configuração do widget
 * @returns {HTMLElement} Elemento do launcher
 */
export function createLauncher(config) {
  const launcher = document.createElement("div");
  launcher.id = "synapsy-launcher";
  launcher.className = "synapsy-launcher";
  launcher.style.cssText = getLauncherStyles(config.position);
  launcher.style.display = "none";
  // Semântica de botão + foco por teclado (o handler de clique/teclado que
  // abre o chat é conectado em index.js via onActivate).
  launcher.setAttribute("role", "button");
  launcher.setAttribute("tabindex", "0");
  launcher.setAttribute("aria-label", "Abrir chat");

  // alt vazio: o nome acessível vem do aria-label do launcher (evita anúncio
  // duplicado da imagem pelo leitor de tela).
  launcher.innerHTML = `
    <img
      src="${avatarDoLauncher(config.iframeUrl)}"
      alt=""
      style="width: 100%; height: 100%; border-radius: 50%; object-fit: cover; display: block;"
    />
  `;

  // A foto do evento vem de outro deploy (o do iframe). Se ela não carregar, o launcher — a
  // única entrada do chat — ficava um círculo vazio o evento inteiro. Volta para a padrão,
  // uma vez só: se a padrão também falhar, não há laço.
  const img = launcher.querySelector("img");
  img?.addEventListener(
    "error",
    () => {
      if (img.src !== ANA_AVATAR_URL) img.src = ANA_AVATAR_URL;
    },
    { once: true },
  );

  return launcher;
}
